import { Link } from "react-router-dom";
import { ShieldCheck, FlaskConical, Truck, Award } from "lucide-react";
import { BRAND, LEGAL } from "@/lib/brand";

export default function Footer() {
  return (
    <footer className="relative z-10 bg-ape-surface border-t border-ape-border mt-auto">
      <div className="border-b border-ape-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: ShieldCheck, t: "3rd Party Lab Tested", s: "Every batch verified" },
            { icon: FlaskConical, t: "99%+ Purity", s: "HPLC validated" },
            { icon: Truck, t: "Discreet Shipping", s: "Secure & fast" },
            { icon: Award, t: "Premium Quality", s: "Made in the USA" },
          ].map((b, i) => (
            <div key={i} className="flex items-center gap-3">
              <b.icon className="text-ape-red shrink-0" size={26} />
              <div>
                <div className="font-head uppercase text-sm tracking-wide">{b.t}</div>
                <div className="text-ape-muted text-xs">{b.s}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={BRAND.logoCircle} alt="APE-TIDES" className="h-16 w-16 object-contain mb-3" />
          <p className="text-ape-muted text-sm leading-relaxed max-w-xs">
            Primal strength. Modern science. Premium research peptides for those who refuse to settle for average.
          </p>
        </div>
        <div>
          <h4 className="font-head uppercase tracking-widest text-sm mb-4 text-ape-red">Shop</h4>
          <ul className="space-y-2 text-sm text-ape-muted">
            <li><Link to="/shop" className="hover:text-white transition-colors duration-150">All Peptides</Link></li>
            <li><Link to="/verify" className="hover:text-white transition-colors duration-150">Verify a Batch</Link></li>
            <li><Link to="/track-order" className="hover:text-white transition-colors duration-150">Track Order</Link></li>
            <li><Link to="/affiliate" className="hover:text-white transition-colors duration-150">Affiliate Program</Link></li>
            <li><Link to="/shipping" className="hover:text-white transition-colors duration-150">Shipping &amp; Refunds</Link></li>
            <li><Link to="/cart" className="hover:text-white transition-colors duration-150">Cart</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-head uppercase tracking-widest text-sm mb-4 text-ape-red">Company</h4>
          <ul className="space-y-2 text-sm text-ape-muted">
            <li><Link to="/about" className="hover:text-white transition-colors duration-150">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors duration-150">Contact</Link></li>
            <li><Link to="/account" className="hover:text-white transition-colors duration-150">My Account</Link></li>
            <li><a href="mailto:ape-tides.support@ape-tides.com" className="hover:text-white transition-colors duration-150">Support Email</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-head uppercase tracking-widest text-sm mb-4 text-ape-red">Mindset</h4>
          <p className="font-display text-xl leading-tight">BUILT DIFFERENT.<br /><span className="text-ape-red">EVOLVE BEYOND LIMITS.</span></p>
        </div>
      </div>

      <div className="bg-ape-red text-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 text-center font-mono2 text-[11px] sm:text-xs font-bold tracking-[0.2em]">
          {LEGAL}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 text-center text-ape-muted text-xs font-mono2">
        © {new Date().getFullYear()} APE-TIDES.COM — All rights reserved. Research chemicals sold for laboratory research purposes only.
      </div>
    </footer>
  );
}
